import React, { useState, useEffect } from "react";
import MatrixTree from "../../components/MatrixTree/MatrixTree";
import { PLAN2_PKG_LABELS } from "../../utils/constants";
import { PLAN2_PKG_COUNT } from "../../config/config";

export default function GlobalTeam({ userId, contracts, maxLevels }) {
  const [directCount, setDirectCount] = useState(0);
  const [totalTeam, setTotalTeam] = useState(0);
  const [selectedPkg, setSelectedPkg] = useState(0);

  useEffect(() => {
    if (userId && contracts) loadData();
    // eslint-disable-next-line
  }, [userId, contracts]);

  async function loadData() {
    try {
      const [count, counts] = await Promise.all([
        contracts.data.getUserDirectCount(userId),
        contracts.plan2.getMatrixLevelCounts(userId, 0),
      ]);
      setDirectCount(count.toNumber());
      setTotalTeam(counts.reduce((s, c) => s + c.toNumber(), 0));
    } catch (err) {
      console.error("GlobalTeam:", err);
    }
  }

  return (
    <div className="plan-team-section">
      <div className="plan-team-stats-row">
        <div className="plan-team-stat">
          <span className="plan-team-stat-value">{directCount}</span>
          <span className="plan-team-stat-label">Direct Refs</span>
        </div>
        <div className="plan-team-stat">
          <span className="plan-team-stat-value">{totalTeam}</span>
          <span className="plan-team-stat-label">Total Team</span>
        </div>
      </div>

      <div className="global-pkg-selector">
        <span className="global-pkg-label">Select Package Matrix</span>
        <div className="global-pkg-chips">
          {Array.from({ length: PLAN2_PKG_COUNT }, (_, i) => (
            <button key={i} className={`global-pkg-chip ${selectedPkg === i ? "global-pkg-chip-active" : ""}`} onClick={() => setSelectedPkg(i)}>
              {PLAN2_PKG_LABELS[i]}
            </button>
          ))}
        </div>
      </div>

      <MatrixTree
        userId={userId}
        planContract={contracts.plan2}
        dataContract={contracts.data}
        maxLevels={maxLevels}
        showUplines={true}
        pkgIndex={selectedPkg}
        pkgCount={PLAN2_PKG_COUNT}
      />
    </div>
  );
}
